module.exports = __webpack_public_path__ + "assets/images/newspapers.f8b8d028.png";


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Error/assets/newspapers.png
// module id = 997
// module chunks = 0